import { FourthDoorContent } from 'shared/components/FourthDoorContent';
import { FOURTH_GIFT_DOOR_LINK } from 'shared/constants/links';
import { useDoorContent } from 'shared/hooks';
import { EAdventDoorsHashs, TDoor } from 'shared/types/doors';

export const FourthDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const { handleClickBtn } = useDoorContent({
    doorCode: EAdventDoorsHashs.FourthDoor,
    giftLink: FOURTH_GIFT_DOOR_LINK,
  });

  return <FourthDoorContent onClickBtn={handleClickBtn} {...props} />;
};
